import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-use'
import slugify from 'slugify'
import PersonCard from '../atoms/PersonCard'
import PersonListCity from '../molecules/PersonListCity'

const M18PeopleList = ({
  heading,
  variant,
  peopleListCities,
  anchorLinkId,
}) => {
  const params =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search)
      : {}
  const cityParam = typeof window !== 'undefined' ? params.get('city') : ''
  const [activeIndex, setActiveIndex] = useState(null)
  const location = useLocation()

  const handleToggle = toggleIndex => {
    const newIndex = toggleIndex !== activeIndex ? toggleIndex : null
    setActiveIndex(newIndex)

    const hash =
      newIndex !== null
        ? slugify(peopleListCities[newIndex].title).toLowerCase()
        : null

    const queryParams = new URLSearchParams(window.location.search)
    if (hash) {
      queryParams.set('city', hash)
    } else {
      queryParams.delete('city')
    }

    window.history.pushState(
      {},
      '',
      `${window.location.pathname}?${queryParams.toString()}`,
    )
  }

  useEffect(() => {
    const cityIndex = peopleListCities?.findIndex(
      ({ title }) => slugify(title).toLowerCase() === cityParam,
    )

    if (cityIndex === -1) {
      return
    }

    window.scrollTo({ top: 0 })

    setTimeout(() => {
      let scrollTop = 0
      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        scrollTop =
          window?.pageYOffset || document?.documentElement.scrollTop || 0
      }

      const top = document.getElementById(cityParam)
        ? document.getElementById(cityParam).getBoundingClientRect().y +
          scrollTop
        : 0
      window.scrollTo({ top: top })
    }, 50)

    if (activeIndex !== cityIndex) {
      setTimeout(() => setActiveIndex(cityIndex), 10)
    }
  }, [cityParam, location, activeIndex, peopleListCities])

  useEffect(() => {
    const peopleScrollToPosition = params => {
      const currentIndex = peopleListCities.findIndex(
        v => v.title === params.detail.country,
      )

      if (currentIndex < 0) {
        return
      }

      const hash =
        currentIndex !== null
          ? slugify(peopleListCities[currentIndex].title).toLowerCase()
          : null

      const queryParams = new URLSearchParams(window.location.search)

      if (hash && currentIndex !== activeIndex) {
        queryParams.set('city', hash)

        window.history.pushState(
          {},
          '',
          `${window.location.pathname}?${queryParams.toString()}`,
        )
      }
    }

    window.addEventListener('peopleScrollToPosition', peopleScrollToPosition)

    return () => {
      window.removeEventListener(
        'peopleScrollToPosition',
        peopleScrollToPosition,
      )
    }
  }, [])

  const [selectorY, setSelectorY] = useState(0)
  const [scaleY, setScale] = useState(0)

  return (
    <section className="my-10 md:my-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-g">
          <div className="col-1-type-g1">
            <h2 className="mb-11 u-h1">{heading}</h2>

            <div className="relative">
              {variant !== 'onlyGrid' &&
                peopleListCities?.map((city, index) => (
                  <PersonListCity
                    key={city.id}
                    city={city}
                    index={index}
                    activeIndex={activeIndex}
                    onToggle={() => handleToggle(index)}
                    onMouseLeave={() => {
                      setScale(0)
                    }}
                    onMouseEnter={el => {
                      if (activeIndex !== index) setScale(1)
                      setSelectorY(el.offsetTop)
                    }}
                  />
                ))}
              {variant === 'onlyGrid' && (
                <div>
                  {peopleListCities.map(city =>
                    city.cityGroups?.map(group => (
                      <div key={group.id} className="pb-16 last:pb-0">
                        {group.heading && (
                          <h3 className="mb-5 u-h3">{group.heading}</h3>
                        )}

                        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                          {group.people?.map(person => (
                            <PersonCard
                              key={person.id}
                              name={person.teamMemberDetails[0].memberName}
                              title={person.teamMemberDetails[0].memberTitle}
                              phone={person.teamMemberDetails[0].phoneNumber}
                              email={person.teamMemberDetails[0].email}
                              pictureUrl={
                                person.teamMemberDetails[0].photo
                                  ? person.teamMemberDetails[0].photo[0]?.url
                                  : null
                              }
                            />
                          ))}
                        </div>
                      </div>
                    )),
                  )}
                </div>
              )}
              <motion.span
                className="selector absolute top-0 left-0 w-full h-[69px] bg-gray-2 z-[-1]"
                animate={{ y: selectorY, scaleY }}
                transition={{
                  type: 'spring',
                  stiffness: 150,
                  bounce: 0,
                  mass: 0.1,
                  velocity: 0,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default M18PeopleList
